import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OpenImageComponent } from './open-image.component';

@NgModule({
    declarations: [OpenImageComponent],
    imports: [
        CommonModule
    ]
})
export class OpenImageModule{}
